/**
 * The editing state is split into mutable and immutable state. Both may come pre-loaded from the server or the URL,
 * but only the mutable state should be altered during the lifetime of the app. The rest of the app relies on the
 * immutability of the immutable part of the editing state.
 *
 * */


import {
    SET_IMMUTABLE_EDITING_DATA,
    SHOW_SAVE_MODAL,
    SET_ROW_EDITED,
    SET_ROW_DELETED,
    SET_ROW_UNDELETED,
    SHOW_CANCEL_MODAL,
    HIDE_EDITING_MODALS,
    REMOVE_ALL_FIELD_ERRORS,
    ADD_FIELD_ERROR,
    CREATE_ADDED_ROW,
    UPDATE_ADDED_ROW
} from "../actions/editing";
import { calculateEditedRows } from "../../utils/data.transformations/editedRows";
import { createNewRegisterTableRow, generateTempRowKey } from "../../utils/misc";
import {deepCopyObject} from "../../../utils/deepCopy";


export const initialImmutableEditingState = {
    editable: false,  // set with pre-loaded state, never with an action
    editingEnabled: false,
    canAddRows: false,
    canDeleteRows: false,
    fields: [],
    rowKeys: [],
    defaults: {},
    options: {},
    inputProperties: {},
};

export function immutableEditing(state = initialImmutableEditingState, action) {
        switch (action.type) {
            case SET_IMMUTABLE_EDITING_DATA:
                return {
                    ...state,
                    editingEnabled: action.editingEnabled,
                    canAddRows: action.canAddRows,
                    canDeleteRows: action.canDeleteRows,
                    fields: action.fields,
                    rowKeys: action.rowKeys,
                    defaults: action.defaults,
                    options: action.options,
                    inputProperties: action.inputProperties,
                };

            default:
                return state
        }
}

export const initialMutableEditingState = {
    showCancelModal: false,
    showSaveModal: false,
    fieldErrors: {
        //  rowKey {
        //      fieldName: <errorMessage>>,
        //  }
    },
    addedRows: {
        //  <rowKey>: {
        //      <fieldName>: <value>,
        //      ...
        //  },
        //  ...
    },
    editedRows: {
        //  <rowKey>: [
        //      {
        //          fieldName: <fieldName>,
        //          initialValue: <initialValue>,  // set on initial edit of this field for this row.
        //      },
        //      ...
        //  ]
    },
    deletedRowKeys: [],
};


export function mutableEditing(state = initialMutableEditingState, action) {
    switch (action.type) {

        case SHOW_SAVE_MODAL:
            return {
                ...state,
                showSaveModal: true
            };

        case SHOW_CANCEL_MODAL:
            return {
                ...state,
                showCancelModal: true
            };

        case HIDE_EDITING_MODALS:
            return {
                ...state,
                showCancelModal: false,
                showSaveModal: false,
            };

        case SET_ROW_EDITED:

            const newEditedRows = calculateEditedRows(action.rowKey, action.fieldName, action.value,
                action.initialValue, state.editedRows);

            return {
                ...state,
                editedRows: newEditedRows,
            };

        case CREATE_ADDED_ROW:

            const newRowKey = generateTempRowKey();
            const newRow = createNewRegisterTableRow(action.fields, action.fieldTypes, action.defaults);

            const newAddedRows = deepCopyObject(state.addedRows);
            newAddedRows[newRowKey] = newRow;

            return {
                ...state,
                addedRows: newAddedRows,
            };

        case UPDATE_ADDED_ROW:

            const newRows = deepCopyObject(state.addedRows);
            newRows[action.rowKey][action.field] = action.value;

            return {
                ...state,
                addedRows: newRows,
            };

        case SET_ROW_DELETED:
            return {
                ...state,
                deletedRowKeys: [ ...state.deletedRowKeys, action.rowKey]
            };

        case SET_ROW_UNDELETED:
            return {
                ...state,
                deletedRowKeys: state.deletedRowKeys.filter(rowKey => ( rowKey !== action.rowKey ) )
            };

        case ADD_FIELD_ERROR:

            const newFieldErrors = deepCopyObject(state.fieldErrors);
            newFieldErrors[action.rowKey] = action.fieldErrors;

            return {
                ...state,
                fieldErrors: newFieldErrors,
            };

        case REMOVE_ALL_FIELD_ERRORS:
            return {
                ...state,
                fieldErrors: {},
            };

        default:
            return state
    }
}
